import { CSSProperties } from 'react';

interface IStyle {
  image: CSSProperties;
}

const styles = (): IStyle => ({
  image: {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
  },
});

export default styles;
